import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Messaging from './Messaging';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title: 'Messaging',
    component: (
      <AdminLayout>
        <Messaging />
      </AdminLayout>
    ),
  };
}

export default action;
